import { useContextFallback } from '@prenuvo/halo';

import { NavMenuContext } from './nav-menu.context';

export const useNavMenu = () => useContextFallback(NavMenuContext);
